var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgImageWithText = function SvgImageWithText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 199 89"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#6C8A8E",
    transform: "translate(-10.5 -6.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84 29c0-4.95-4.05-9-9-9H39c-4.95 0-9 4.05-9 9v27c0 4.95 4.05 9 9 9h36c4.95 0 9-4.05 9-9zm-40.5 0c2.475 0 4.5 2.025 4.5 4.5S45.975 38 43.5 38a4.513 4.513 0 0 1-4.5-4.5c0-2.475 2.025-4.5 4.5-4.5m36 27c0 2.475-2.025 4.5-4.5 4.5H39.9c-2.025 0-2.925-2.475-1.575-3.825l8.1-8.1c.9-.9 2.25-.9 3.15 0l1.35 1.35c.9.9 2.25.9 3.15 0l14.85-14.85c.9-.9 2.25-.9 3.15 0l6.75 6.75c.45.45.675.9.675 1.575z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 5,
    x: 93,
    y: 20,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 2,
    x: 93,
    y: 30,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 2,
    x: 93,
    y: 37,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 2,
    x: 93,
    y: 44,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 2,
    x: 93,
    y: 51,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 2,
    x: 93,
    y: 58,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 2,
    x: 93,
    y: 65,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 2,
    x: 93,
    y: 72,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 2,
    x: 93,
    y: 79,
    rx: 1
  }))));
};
export { SvgImageWithText as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTk5IDg5IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPg0KPGcgdHJhbnNmb3JtPSd0cmFuc2xhdGUoLTEwLjUgLTYuNSknPg0KPHBhdGggZD0iTTg0IDI5Qzg0IDI0LjA1IDc5Ljk1IDIwIDc1IDIwSDM5QzM0LjA1IDIwIDMwIDI0LjA1IDMwIDI5VjU2QzMwIDYwLjk1IDM0LjA1IDY1IDM5IDY1SDc1Qzc5Ljk1IDY1IDg0IDYwLjk1IDg0IDU2VjI5Wk00My41IDI5QzQ1Ljk3NSAyOSA0OCAzMS4wMjUgNDggMzMuNUM0OCAzNS45NzUgNDUuOTc1IDM4IDQzLjUgMzhDNDEuMDI1IDM4IDM5IDM1Ljk3NSAzOSAzMy41QzM5IDMxLjAyNSA0MS4wMjUgMjkgNDMuNSAyOVpNNzkuNSA1NkM3OS41IDU4LjQ3NSA3Ny40NzUgNjAuNSA3NSA2MC41SDM5LjlDMzcuODc1IDYwLjUgMzYuOTc1IDU4LjAyNSAzOC4zMjUgNTYuNjc1TDQ2LjQyNSA0OC41NzVDNDcuMzI1IDQ3LjY3NSA0OC42NzUgNDcuNjc1IDQ5LjU3NSA0OC41NzVMNTAuOTI1IDQ5LjkyNUM1MS44MjUgNTAuODI1IDUzLjE3NSA1MC44MjUgNTQuMDc1IDQ5LjkyNUw2OC45MjUgMzUuMDc1QzY5LjgyNSAzNC4xNzUgNzEuMTc1IDM0LjE3NSA3Mi4wNzUgMzUuMDc1TDc4LjgyNSA0MS44MjVDNzkuMjc1IDQyLjI3NSA3OS41IDQyLjcyNSA3OS41IDQzLjRWNTZaIiBmaWxsPSIjNkM4QThFIi8+DQo8cmVjdCB4PSI5MyIgeT0iMjAiIHdpZHRoPSI2NyIgaGVpZ2h0PSI1IiByeD0iMi41IiBmaWxsPSIjNkM4QThFIi8+DQo8cmVjdCB4PSI5MyIgeT0iMzAiIHdpZHRoPSI5NiIgaGVpZ2h0PSIyIiByeD0iMSIgZmlsbD0iIzZDOEE4RSIvPg0KPHJlY3QgeD0iOTMiIHk9IjM3IiB3aWR0aD0iOTYiIGhlaWdodD0iMiIgcng9IjEiIGZpbGw9IiM2QzhBOEUiLz4NCjxyZWN0IHg9IjkzIiB5PSI0NCIgd2lkdGg9Ijk2IiBoZWlnaHQ9IjIiIHJ4PSIxIiBmaWxsPSIjNkM4QThFIi8+DQo8cmVjdCB4PSI5MyIgeT0iNTEiIHdpZHRoPSI5NiIgaGVpZ2h0PSIyIiByeD0iMSIgZmlsbD0iIzZDOEE4RSIvPg0KPHJlY3QgeD0iOTMiIHk9IjU4IiB3aWR0aD0iOTYiIGhlaWdodD0iMiIgcng9IjEiIGZpbGw9IiM2QzhBOEUiLz4NCjxyZWN0IHg9IjkzIiB5PSI2NSIgd2lkdGg9Ijk2IiBoZWlnaHQ9IjIiIHJ4PSIxIiBmaWxsPSIjNkM4QThFIi8+DQo8cmVjdCB4PSI5MyIgeT0iNzIiIHdpZHRoPSI5NiIgaGVpZ2h0PSIyIiByeD0iMSIgZmlsbD0iIzZDOEE4RSIvPg0KPHJlY3QgeD0iOTMiIHk9Ijc5IiB3aWR0aD0iNDAiIGhlaWdodD0iMiIgcng9IjEiIGZpbGw9IiM2QzhBOEUiLz4NCjwvZz4NCjwvc3ZnPg0K";